





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { CancelarSolicitacaoParam, Equipamento, Procedimento, TipoOrigemEnum, StatusCirurgiaEnum, IRequestMessage, RequestMessage, TipoDocumentoUpload, Solicitacao } from '@/types/_'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import BackofficeMapaCirurgicoStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import BackofficeDataAgendamentoStore from '@/components/Backoffice/Store/BackofficeDataAgendamentoStore'
import ChatStore from '@/components/Chat/Store/ChatStore'
import { timeout, humanTime, onlyNumber, formatDateOnly, maskPhone, displayLateralidade, maskDateTime } from '@/utils/common'
import moment from 'moment'
import Apis from '@/Apis/_'
import RecursosHospitalaresStore from '@/components/RecursosHospitalares/Store/RecursosHospitalaresStore'
import AvaliacaoRiscoApaStore from '@/components/AvaliacaoRiscoApa/Store/AvaliacaoRiscoApaStore'

/** EventBus */
import EventBus from '@/plugins/EventBus'
import { ConfirmacaoCirurgicaParam } from '@/types/interfaces/confirmacao-cirurgica'
// eslint-disable-next-line import/no-unresolved
import ConfirmacaoCirurgicaStore from '@/components/confirmacao-cirurgica/store/confirmacao-cirurgica-store'
import { ConfirmacaoCirurgicaStatusEnum, ConfirmacaoCirurgica } from '@/types/interfaces/Solicitacao'
import { AceiteMedicoAutorizacaoParcialMixin } from '@/mixins/solicitacao'

@Component({ filters: { humanTime } })
export default class ViewBackofficeMapaCirurgico extends mixins(AceiteMedicoAutorizacaoParcialMixin) {
  $refs!: {
    search: any,
    motivo: any,
    comentario: any,
    cirurgiaDe: any,
    cirurgiaAte: any,
  }

  solicitacaoId: string = ''
  exp: boolean = false
  eMotivo: boolean = false
  eComentario: boolean = false
  loadCancelamento: boolean = false
  loadAlterarDataAgendamento: boolean = false
  loadCirurgiaRealizada: string = ''
  loadVisualizar: string = ''
  loadAlterarReserva: string = ''
  dataAgendamento: string = ''
  loadingSearch: boolean = false
  loadingVerifyPatientEligibility: string = ''

  // Loaders
  lexcl: boolean = false
  lfnsh: boolean = false
  lhsty: boolean = false
  lcmmt: boolean = false
  lcfrm: boolean = false
  lncfm: boolean = false
  loadPedidoSemAssinatura: boolean = false
  getRequestMessage: IRequestMessage = new RequestMessage()

  modDe: boolean = false
  modAte: boolean = false

  eligibilityStatuses = [
    { description: 'Elegível', value: 'Elegivel' },
    { description: 'Não elegível', value: 'NaoElegivel' },
  ]

  get modalDe() { return this.modDe }
  set modalDe(value: boolean) { this.modDe = value }
  get modalAte() { return this.modAte }
  set modalAte(value: boolean) { this.modAte = value }

  get de() { return this.getBackofficeMapaCirurgicoStore.deFiltro }
  set de(value: Date | string | null) { this.getBackofficeMapaCirurgicoStore.setDeFiltro(value) }
  get ate() { return this.getBackofficeMapaCirurgicoStore.ateFiltro }
  set ate(value: Date | string | null) { this.getBackofficeMapaCirurgicoStore.setAteFiltro(value) }
  get formattedDe() { return this.formatDate(this.de) }
  get formattedAte() { return this.formatDate(this.ate) }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  resetModalAte() {
    this.ate = null
    this.modalAte = false
  }

  formatDate(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
      this.ate = null
    } else {
      this.ate = null
    }
  }

  formatTecnicaDaCirurgia(tecnica: string) {
    switch (tecnica) {
      case 'Robotica':
        return 'Robótica'
      case 'Video':
        return 'Vídeo'
      case 'Convencional':
        return 'Convencional'
      default:
        return ''
    }
  }

  async onElegibilityStatusChange(elegibilityStatus: 'Elegivel' | 'NaoElegivel') {
    this.getBackofficeMapaCirurgicoStore.setElegibilityStatus(elegibilityStatus)
  }


  get getBackofficeMapaCirurgicoStore() {
    return getModule(BackofficeMapaCirurgicoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getRecursosHospitalaresStore() {
    return getModule(RecursosHospitalaresStore, this.$store)
  }

  get getAvaliacaoRiscoApaStore() {
    return getModule(AvaliacaoRiscoApaStore, this.$store)
  }

  get headers() {
    const defaultHeaders = [
      { text: '', class: 'table-headers-email', align: 'left', value: '', tooltip: '', sortable: false },
      { text: 'Cirurgia realizada', class: 'table-headers-email', align: 'left', value: 'statusCirurgia', tooltip: '', sortable: false },
      { text: 'Nº da reserva', class: 'table-headers-email', align: 'left', value: 'numeroAgendamento', tooltip: '', sortable: false },
      { text: 'Paciente', class: 'table-headers-email', align: 'left', value: 'pacienteNome', tooltip: '', sortable: false },
      { text: 'Médico', class: 'table-headers-email', align: 'left', value: 'nomeMedico', tooltip: '', sortable: false },
      { text: 'Caráter', class: 'table-headers-email', align: 'left', value: 'carater', tooltip: '', sortable: false },
      { text: 'Sala', class: 'table-headers-email', align: 'left', value: 'salaCirurgicaNome', tooltip: '', sortable: false },
      { text: 'Horário', class: 'table-headers-email', align: 'left', value: 'dataAgendamento', tooltip: '', sortable: false },
      { text: 'Status', class: 'table-headers-email', align: 'left', value: 'situacao', tooltip: '', sortable: false },
      { text: 'Parcial c/ aceite médico', class: 'table-headers-email', align: 'left', value: 'autorizacaoParcialAceitaPeloMedico', tooltip: 'Autorização parcial que teve aceite do médico para prosseguir.', sortable: false },
    ]

    if (this.bateMapaTemplate.elegibilidade) {
      defaultHeaders.push({ text: 'Elegibilidade', class: 'table-headers-email', align: 'left', value: 'elegibilidade', tooltip: '', sortable: false })
      defaultHeaders.push({
        text: 'Verificação Elegibilidade',
        class: 'table-headers-email',
        align: 'left',
        value: 'verificacaoElegibilidade',
        tooltip: 'Análise automática de elegibilidade realizada em determinados horários antes da cirurgia.',
        sortable: false,
      })
    }

    return [
      ...defaultHeaders,
      { text: '', class: 'table-headers-email', align: 'left', value: '', sortable: false },
    ]
  }

  get surgerySolicitationsLength() {
    return this.items.length
  }

  get items() {
    // return this.getBackofficeMapaCirurgicoStore.itensMapaCirurgico
    return this.getBackofficeMapaCirurgicoStore.itensMapaCirurgicoFiltered
  }

  get openMapaCirurgico() {
    return this.getBackofficeMapaCirurgicoStore.modal.mapaCirurgico
  }

  set openMapaCirurgico(value: boolean) {
    this.getBackofficeMapaCirurgicoStore.setShowModalMapaCirurgico(value)
  }

  get loadingCirurgiaRealizada() {
    return this.loadCirurgiaRealizada
  }

  set loadingCirurgiaRealizada(value: string) {
    this.loadCirurgiaRealizada = value
  }

  get loadingAlterarReserva() {
    return this.loadAlterarReserva
  }

  set loadingAlterarReserva(value: string) {
    this.loadAlterarReserva = value
  }

  get loadingPedidoSemAssinatura() {
    return this.loadPedidoSemAssinatura
  }

  set loadingPedidoSemAssinatura(value: boolean) {
    this.loadPedidoSemAssinatura = value
  }

  get openAnexos() {
    return this.getBackofficeMapaCirurgicoStore.modal.anexos
  }

  set openAnexos(value: boolean) {
    this.getBackofficeMapaCirurgicoStore.setShowModalAnexos(value)
  }

  get openExclusao() {
    return this.getBackofficeMapaCirurgicoStore.modal.exclusao
  }

  set openExclusao(value: boolean) {
    this.getBackofficeMapaCirurgicoStore.setShowModalExclusao(value)
  }

  get openAcoes() {
    return this.getBackofficeMapaCirurgicoStore.modal.acoes
  }

  set openAcoes(value: boolean) {
    this.getBackofficeMapaCirurgicoStore.setShowModalAcoes(value)
  }

  get anexos() {
    return this.getBackofficeMapaCirurgicoStore.anexos
  }

  get acao() {
    return this.getBackofficeMapaCirurgicoStore.acao
  }

  get expand() {
    return this.exp
  }

  set expand(value: boolean) {
    this.exp = value
  }

  get search() {
    return this.getBackofficeMapaCirurgicoStore.search
  }

  set search(value: string) {
    this.getBackofficeMapaCirurgicoStore.setSearch(value)
  }

  get excluirLoading() {
    return this.lexcl
  }

  set excluirLoading(value: boolean) {
    this.lexcl = value
  }

  get historyLoading() {
    return this.lhsty
  }

  set historyLoading(value: boolean) {
    this.lhsty = value
  }

  get commentsLoading() {
    return this.lcmmt
  }

  set commentsLoading(value: boolean) {
    this.lcmmt = value
  }

  get finishLoading() {
    return this.lfnsh
  }

  set finishLoading(value: boolean) {
    this.lfnsh = value
  }

  get confirmLoading() {
    return this.lcfrm
  }

  set confirmLoading(value: boolean) {
    this.lcfrm = value
  }

  get notConfirmLoading() {
    return this.lncfm
  }

  set notConfirmLoading(value: boolean) {
    this.lncfm = value
  }

  get errorMotivo() {
    return this.eMotivo
  }

  set errorMotivo(value: boolean) {
    this.eMotivo = value
  }

  get errorComentario() {
    return this.eComentario
  }

  set errorComentario(value: boolean) {
    this.eComentario = value
  }

  get convenios() {
    return this.getBackofficeMapaCirurgicoStore.convenios
  }

  get convenio() {
    return this.getBackofficeMapaCirurgicoStore.convenio
  }

  set convenio(value: string) {
    this.getBackofficeMapaCirurgicoStore.setConvenio(value)
  }

  get medico() {
    return this.getBackofficeMapaCirurgicoStore.medico
  }

  set medico(value: string) {
    this.getBackofficeMapaCirurgicoStore.setMedico(value)
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(value: string) {
    this.loadVisualizar = value
  }

  get drawer() {
    return this.getBackofficeMapaCirurgicoStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeMapaCirurgicoStore.setFilterDrawer(value)
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingAlterarDataAgendamento() {
    return this.loadAlterarDataAgendamento
  }

  set loadingAlterarDataAgendamento(value: boolean) {
    this.loadAlterarDataAgendamento = value
  }

  get getDataAgendamento() {
    return this.dataAgendamento
  }

  set getDataAgendamento(value: string) {
    this.dataAgendamento = value
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getConfirmacaoCirurgicaStore() {
    return getModule(ConfirmacaoCirurgicaStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoId() {
    return this.solicitacaoId
  }

  set getSolicitacaoId(value: string) {
    this.solicitacaoId = value
  }

  classificacaoCirurgia(classificacaoCirurgia: string) {
    const classificacao = new Map([
      ['Limpa', 'Limpa'],
      ['PotencialmenteContaminada', 'Potencialmente contaminada'],
      ['Contaminada', 'Contaminada'],
      ['Infectada', 'Infectada'],
    ])
    return classificacao.get(String(classificacaoCirurgia)) || 'Não informado'
  }

  eligibilityVerificationErrorDescription(surgerySolicitation) {
    const { horariosConsultaAutomatica, elegibilidade } = surgerySolicitation

    if (surgerySolicitation.erroVerificacaoElegibilidade) {
      return surgerySolicitation.erroVerificacaoElegibilidade
    }

    if (horariosConsultaAutomatica && horariosConsultaAutomatica.length > 0) {
      const horariosConsultaAutomaticaError = horariosConsultaAutomatica.reduce((currentMin, item) => {
        if (!item.erroVerificacaoElegibilidade) {
          return currentMin
        }

        if (!currentMin) {
          return item
        }

        return Number(item.descricao) < Number(currentMin.descricao)
          ? item
          : currentMin
      }, null)

      if (horariosConsultaAutomaticaError) {
        return horariosConsultaAutomaticaError.erroVerificacaoElegibilidade
      }
    }

    return '-'
  }

  async verifyPatientEligibility(surgerySolicitationId: string) {
    try {
      this.loadingVerifyPatientEligibility = surgerySolicitationId

      const APIResponseVerifyPatientEligibility = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.verifyPatientEligibility(surgerySolicitationId)

      if (APIResponseVerifyPatientEligibility.success) {
        EventBus.$emit('setSnackbar', { show: true, text: APIResponseVerifyPatientEligibility.message || 'Verificação finalizada. Atualize a página para conferir as alterações', icon: 'done', color: '#2E7D32' })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: APIResponseVerifyPatientEligibility.message || 'Não foi possível concluir o processo de verificação de elegibilidade', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível concluir o processo de verificação de elegibilidade', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingVerifyPatientEligibility = ''
    }
  }

  async showModalConfirmacaoCirurgica(solicitacaoItem: Solicitacao) {
    const data: ConfirmacaoCirurgicaParam = {
      solicitacaoId: solicitacaoItem.id,
      templateMapaCirurgico: solicitacaoItem.templateMapaCirurgico,
      confirmacaoCirurgiaMedico: solicitacaoItem.confirmacaoCirurgiaMedico,
      confirmacaoCirurgiaPaciente: solicitacaoItem.confirmacaoCirurgiaPaciente,
      telefonePaciente: solicitacaoItem.celular,
      telefoneMedico: solicitacaoItem.medicoSolicitante.telefone,
    }

    this.getConfirmacaoCirurgicaStore.setConfirmacaoCirurgicaParam(data)
    this.getConfirmacaoCirurgicaStore.setShowModalConfirmacaoCirurgica(true)
  }

  async showModalCancelamento(solicitacaoItem: any) {
    this.loadingCancelamento = true
    await timeout(400)
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: solicitacaoItem.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'mapaCirurgico',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: solicitacaoItem.hospitalId })
    this.loadingCancelamento = false
  }

  async showModalAlteracaoDataAgendamento(solicitacaoItem: any) {
    this.loadingAlterarDataAgendamento = true
    this.getSolicitacaoId = solicitacaoItem.id

    if (this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada
      && this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data) {
      this.getDataAgendamento = `${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.data} ${this.getSolicitacaoPendenciaStore.agendamentoMedico.dataAutorizada.hora} `
    }

    await this.getChatStore.getDataAgendamento(solicitacaoItem.id)
    this.getSolicitacaoStore.setShowAlteracaoDataAgendamento(true)
    this.loadingAlterarDataAgendamento = false
  }

  async showAlterarReserva(agendamentoItem: any) {
    this.loadingAlterarReserva = agendamentoItem.id

    await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoItem.id)

    if (this.getBackofficeGlobalStore.componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoItem.id)
      if (response.success) {
        await this.getChatStore.getDataAgendamento(agendamentoItem.id)
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoItem.hospitalId)
        this.getBackofficeGlobalStore.setMapaCirurgicoAlterarReserva(true)
        this.getBackofficeGlobalStore.setModal({ name: 'reservaDeSala', value: true })
      }
    } else {
      const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoItem.id)
      if (response.success) {
        await this.getBackofficeGlobalStore.getSolicitacaoById(agendamentoItem.id)
        const item = this.getBackofficeGlobalStore.solicitacao
        this.getBackofficeGlobalStore.setMapaCirurgicoAlterarReserva(true)
        await this.getChatStore.getDataAgendamento(agendamentoItem.id)
        // @ts-ignore
        await this.getBackofficeDataAgendamentoStore.setAgendamentoItem({ ...item })
        this.getBackofficeDataAgendamentoStore.setModal({ name: 'confirmarDataAgendamento', value: true })
      }
    }

    this.loadingAlterarReserva = ''
    this.ga('backoffice-mapa-cirurgico', 'alterar-reserva')
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getBackofficeMapaCirurgicoStore.clearFiltro()
    this.getBackofficeMapaCirurgicoStore.setFilterOn(false)
    this.drawer = false
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.post })
    await this.getBackofficeMapaCirurgicoStore.loadAgendamentosMedicoSearch()
    EventBus.$emit('clearLoadingRequest')
  }

  ga(event: string, action: string) {
    // @ts-ignore
    this.$ga.event(event, action, this.$user.profile.email)
  }

  precaucoes(item) {
    if (item.precaucoes && item.precaucoes.key === 'Sim') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'Outro') return item.especificarPrecaucoes
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorGoticulas') return 'Precaução respiratória por gotículas'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoRespiratoriaPorAerosol') return 'Precaução respiratória por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoPorContatoERespiratoriaPorAerosol') return 'Precaução por contato respiratório por aerosol'
    if (item.precaucoes && item.precaucoes.key === 'PrecaucaoEspecial') return 'Precaução especial'
    return 'Não'
  }

  anestesiaDoHospital(item) {
    if (item.anestesiaDoHospital === 'Sim') return 'Sim'
    if (item.anestesiaDoHospital === 'Nao') return 'Não'
    if (item.anestesiaDoHospital === 'NaoAplica') return 'Não se aplica'
    return ''
  }

  formatComorbidadesDoPaciente(comorbidades) {
    let text = ''
    comorbidades.forEach((e) => {
      text += `${e.descricao || e.comorbidade}${e.informacao ? ` [${e.informacao}]` : ''}, `
    })
    return text.substring(0, text.length - 2)
  }

  filterMedicos(e) {
    this.getBackofficeMapaCirurgicoStore.filterMapaCirurgicoByMedico(e)
  }

  filterConvenios(items, search, filter) {
    return items.filter(({ convenioNome }) => {
      if (search.length < 1) return items
      const s = search.map((e: string) => e.toLowerCase())
      const cNome = convenioNome.toLowerCase()
      return s.includes(cNome)
    })
  }

  compareDate() {
    const today = moment().format('YYYY-MM-DD').toString()
    // @ts-ignore
    return ['', null, undefined].includes(this.de)
      ? false
      : moment(this.de).isSameOrAfter(today)
  }

  maskPhoneUtil(value) {
    return maskPhone(value)
  }

  formatDateOnlyUtil(value) {
    return formatDateOnly(value)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  formatDateMask(value) {
    return maskDateTime(value)
  }

  displaySetor(str: string) {
    switch (str.toLowerCase()) {
      case 'farmacia':
        return 'Farmácia'
      case 'centrocirurgico':
        return 'Centro cirúrgico'
      case 'preinternacao':
        return 'Pré internação'
      case 'autorizacao':
        return 'Autorização'
      case 'suprimentos':
        return 'Suprimentos'
      case 'centraldemateriaisespeciais':
        return 'CME - Central de materiais especiais'
      case 'engenhariaclinica':
        return 'Engenharia clínica'
      case 'opme':
        return 'Opme'
      case 'anestesia':
        return 'Anestesia'
      case 'hotelaria':
        return 'Hotelaria'
      case 'gerenciamentoleito':
        return 'Gerenciamento de leitos'
      case 'bancodesangue':
        return 'Banco de sangue'
      case 'tesouraria':
        return 'Tesouraria'
      default:
        return 'Agendamento'
    }
  }

  displayActiveCursor(areaMapaCirurgico: string) {
    return this.$user.profile.roles.includes(this.checkAreaMapaCirurgico(areaMapaCirurgico))
  }

  displayConfirmSetor(status: boolean | null | undefined) {
    switch (status) {
      case true:
        return { color: 'green darken-2', icon: 'mdi-check-circle-outline' }
      case false:
        return { color: 'red darken-2', icon: 'mdi-close-circle-outline' }
      default:
        return { color: 'indigo darken-2', icon: 'mdi-checkbox-blank-circle-outline' }
    }
  }

  displayConfirmSetorConfirmacaoCirurgia(data: ConfirmacaoCirurgica) {
    const status = data ? data.status : null

    switch (status) {
      case ConfirmacaoCirurgicaStatusEnum.confirmado:
        return { color: 'green darken-2', icon: 'mdi-check-circle-outline' }
      case ConfirmacaoCirurgicaStatusEnum.recusado:
        return { color: 'red darken-2', icon: 'mdi-close-circle-outline' }
      case ConfirmacaoCirurgicaStatusEnum.pendente:
        return { color: 'yellow darken-2', icon: 'mdi-timer-outline' }
      default:
        return { color: 'indigo darken-2', icon: 'mdi-checkbox-blank-circle-outline' }
    }
  }

  displayStatusCirurgia(str: string) {
    switch (str) {
      case 'CirurgiaNaoConfirmada':
        return 'red darken-1'
      case 'NaoAvaliada':
        return 'orange darken-4'
      case 'Avaliada':
        return 'blue darken-1'
      default:
        return 'green lighten-1'
    }
  }

  elegibilityChipStyleConfiguration({ descricao, status, erroVerificacaoElegibilidade }: {
      descricao: string,
      erroVerificacaoElegibilidade: string,
      status: 'Elegivel' | 'NaoElegivel' | 'NaoVerificada'
    }): {
    backgroundColor: string,
    textColor: string,
    border: string
  } {
    const styleDefault = { backgroundColor: '#F0F0F0', textColor: '#ADAEBC', border: '0.8px solid #DFDFDF' }

    if (erroVerificacaoElegibilidade) {
      return { backgroundColor: '#FFE2E2', textColor: '#C10007', border: '0.8px solid #FFC9C9' }
    }

    switch (status) {
      case 'Elegivel':
        return { backgroundColor: '#DCFCE7', textColor: '#008236', border: '0.8px solid #B9F8CF' }
      case 'NaoElegivel':
        return { backgroundColor: '#FFE2E2', textColor: '#C10007', border: '0.8px solid #FFC9C9' }
      case 'NaoVerificada':
        return styleDefault
      default:
        return styleDefault
    }
  }

  displayReservaHemocomponentes(item: any) {
    if (item.solicitacaoReservaDeSangue) {
      return `Concentrado de hemácias - qtde: ${item.solicitacaoReservaDeSangue.concentradoDeHemacias.quantidade}
              Concentrado de plaquetas - qtde: ${item.solicitacaoReservaDeSangue.concentradoDePlaquetas.quantidade}
              Plasma fresco congelado - qtde: ${item.solicitacaoReservaDeSangue.plasmaFrescoCongelado.quantidade}
              Crioprecipitado  - qtde: ${item.solicitacaoReservaDeSangue.criptoprecipitado.quantidade}
             `
    }
    return item.reservaHemocomponentes.map((reserva) => {
      if (reserva.key === 'SemReserva') return 'Não'
      return `${reserva.display} - qtde: ${reserva.quantidade}`
    }).join('; ')
  }

  displayEquipamentos(equipamentos: Equipamento[]) {
    if (!equipamentos || equipamentos.length < 1) return 'Nenhum'
    return equipamentos.map(e => `${e.nome}`).join(', ')
  }

  displayProcedimento(procedimento: Procedimento) {
    return `${procedimento.codigo} - ${procedimento.descricao}${procedimento.porte ? ` - ${procedimento.porte}` : ''}${procedimento.particular ? ' - (particular)' : ''} Lateralidade: ${this.displayLateralidadeUtil(procedimento.lateralidade).toLowerCase()} -  solicitada: ${procedimento.quantidade} - autorizada: ${procedimento.quantidadeAutorizada ? procedimento.quantidadeAutorizada : 'não informado'}`
  }

  displayLateralidadeUtil(lateralidade: any) {
    return displayLateralidade(lateralidade.key)
  }

  displayExamesIntraOperatorios(exames: any[]) {
    if (exames.length < 1) return 'Não'
    return exames.map(e => `${e.display}`).join(', ')
  }

  displayStatusPrecificacaoOperadora(item: any) {
    switch (item.key.toLowerCase()) {
      case 'precificacaopendente':
        return 'Precificação pendente'
      case 'precificado':
        return 'Precificado'
      default:
        return ''
    }
  }

  closeModalAnexos() {
    this.getBackofficeMapaCirurgicoStore.clearAnexos()
    this.getBackofficeMapaCirurgicoStore.setShowModalAnexos(false)
    this.getSolicitacaoId = ''
  }

  closeModalExclusao() {
    this.errorMotivo = false
    this.$refs.motivo.reset()
    this.getBackofficeMapaCirurgicoStore.clearExclusaoId()
    this.getBackofficeMapaCirurgicoStore.setShowModalExclusao(false)
  }

  closeModalAcoes() {
    this.errorComentario = false
    this.$refs.comentario.reset()
    this.getBackofficeMapaCirurgicoStore.clearAcao()
    this.getBackofficeMapaCirurgicoStore.setShowModalAcoes(false)
  }

  confirmExclusao(id: string) {
    this.getBackofficeMapaCirurgicoStore.setExclusaoId(id)
    this.openExclusao = true
  }

  async showAnexos(item: any) {
    const { laudos } = item
    this.getSolicitacaoId = item.id
    if (item.url && item.url !== '') laudos.push({ pedidoMedico: true, particular: false, url: item.url || '' })
    if (item.urlNaoParticular && item.urlNaoParticular !== '') laudos.push({ pedidoMedico: true, particular: true, url: item.urlNaoParticular || '' })
    this.getBackofficeMapaCirurgicoStore.setAnexos(laudos)

    this.openAnexos = true
  }

  async showSolicitacao(item: any) {
    const { hospitalId } = item
    const solicitacaoId = item.id
    this.loadingVisualizar = solicitacaoId

    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
      this.getBackofficeGlobalStore.setDisableCancelarSolicitacaoButton(true)

      this.getBackofficeGlobalStore.setBackofficeArea('agendamento')
      this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
      this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.ga('backoffice-mapa-cirurgico', 'visualizar')
    this.loadingVisualizar = ''
  }

  checkAreaMapaCirurgico(areaMapaCirurgico: string) {
    switch (areaMapaCirurgico.toLowerCase()) {
      case 'agendamento':
        return 'backoffice-mapa-agendamento'
      case 'autorizacao':
        return 'backoffice-mapa-autorizacao'
      case 'suprimentos':
        return 'backoffice-mapa-suprimentos'
      case 'farmacia':
        return 'backoffice-mapa-farmacia'
      case 'centrocirurgico':
        return 'backoffice-mapa-centrocirurgico'
      case 'centraldemateriaisespeciais':
        return 'backoffice-mapa-centralmateriaisespeciais'
      case 'engenhariaclinica':
        return 'backoffice-mapa-engenhariaclinica'
      case 'preinternacao':
        return 'backoffice-mapa-preinternacao'
      case 'opme':
        return 'backoffice-mapa-opme'
      case 'hotelaria':
        return 'backoffice-mapa-hotelaria'
      case 'anestesia':
        return 'backoffice-mapa-anestesia'
      case 'gerenciamentoleito':
        return 'backoffice-mapa-gerenciamentoleito'
      case 'bancodesangue':
        return 'backoffice-mapa-bancodesangue'
      case 'tesouraria':
        return 'backoffice-mapa-tesouraria'
      default:
        return ''
    }
  }

  showAcoes(id: string, areaMapaCirurgico: string) {
    // @ts-ignore
    if (!this.$user.profile.roles.includes(this.checkAreaMapaCirurgico(areaMapaCirurgico))) return false
    this.getBackofficeMapaCirurgicoStore.setAcao({ solicitacaoId: id, areaMapaCirurgico, comentario: '', confirmacao: null })
    this.getBackofficeMapaCirurgicoStore.setShowModalAcoes(true)
    return true
  }

  async cirurgiaRealizada(solicitacao: any) {
    this.loadingCirurgiaRealizada = solicitacao.id

    const params: any = {
      solicitacaoId: solicitacao.id,
      statusCirurgia: solicitacao.statusCirurgia ? StatusCirurgiaEnum.Realizada : StatusCirurgiaEnum.NaoRealizada, // : StatusCirurgiaEnum.NaoRealizada,
    }

    const response = await this.getBackofficeMapaCirurgicoStore.putCirurgiaRealizada(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação alterada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingCirurgiaRealizada = ''
  }

  async searchSurgerySolicitations() {
    this.loadingSearch = true

    if (this.de) {
      await this.getBackofficeMapaCirurgicoStore.loadAgendamentosMedicoSearch()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de data inicial (De)', icon: 'warning', color: '#C62828' })
  }

    this.loadingSearch = false
  }


  async showHistory(id: string) {
    this.historyLoading = true
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(id)
    this.historyLoading = false
  }

  async showComentarios(id: string) {
    this.commentsLoading = true
    await this.getComentariosStore.getComentariosBySolicitacaoId(id)
    this.getComentariosStore.setShowModalComentario(true)
    this.commentsLoading = false
  }

  async confirmarAcao(confirmacao: boolean) {
    const cfm = confirmacao === false ? 'notConfirmLoading' : 'confirmLoading'

    if (['', null, undefined].includes(this.$refs.comentario.lazyValue) && confirmacao === false) {
      this.errorComentario = true
      return false
    }

    this[cfm] = true

    const payload = { confirmacao, comentario: this.$refs.comentario.lazyValue || '' }
    const response = await this.getBackofficeMapaCirurgicoStore.confirmarAcao(payload)
    if (response.success) {
      this.getBackofficeMapaCirurgicoStore.clearAcao()
      this.closeModalAcoes()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao confirmar a solicitação.', icon: 'warning', color: '#C62828' })
    }

    this[cfm] = false
    return true
  }

  async removerSolicitacao() {
    if (['', null, undefined].includes(this.$refs.motivo.lazyValue)) {
      this.errorMotivo = true
      return false
    }

    this.excluirLoading = true
    const payload = { motivo: this.$refs.motivo.lazyValue }
    const response = await this.getBackofficeMapaCirurgicoStore.removerSolicicitacao(payload)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação removida com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao remover solicitação.', icon: 'warning', color: '#C62828' })
    }

    this.excluirLoading = false
    this.closeModalExclusao()
    return false
  }

  async finalizarMapa() {
    this.finishLoading = true
    const response = await this.getBackofficeMapaCirurgicoStore.finalizarMapa()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Mapa cirúrgico finalizado com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao finalizar o mapa.', icon: 'warning', color: '#C62828' })
    }
    this.finishLoading = false
  }

  get getChatStore() {
    return getModule(ChatStore, this.$store)
  }

  get getBackofficeDataAgendamentoStore() {
    return getModule(BackofficeDataAgendamentoStore, this.$store)
  }

  async gerarPedidoSemAssinatura() {
    this.loadingPedidoSemAssinatura = true
    const response = await this.getBackofficeGlobalStore.gerarPedidoSemAssinatura(this.getSolicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pedido gerado com sucesso! Atualize a página para visualizar o seu documento.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possivel gerar o pedido sem assinatura', icon: 'warning', color: '#C62828' })
    }
    this.loadingPedidoSemAssinatura = false
  }

  beforeDestroy() {
    this.expand = false
    this.convenio = ''
    this.clearDate('de')
    this.getBackofficeMapaCirurgicoStore.clearItensMapaCirurgico()
    this.getBackofficeMapaCirurgicoStore.setShowModalMapaCirurgico(false)
    this.getBackofficeGlobalStore.setBackofficeArea('')
    // this.getRecursosHospitalaresStore.clearResourceAccess()
  }

  @Watch('search')
  async onChangeSearch(value: string) {
    if (value.length === 8) {
      await this.getBackofficeMapaCirurgicoStore.loadAgendamentosMedicoSearch()
    } else {
      this.getBackofficeMapaCirurgicoStore.clearItensMapaCirurgico()
      this.getBackofficeMapaCirurgicoStore.setMapaFinalizado(false)
    }
  }

  get getPedidoMedico() {
    const anexos: any[] = []
    const pedidoMedico: boolean = this.anexos.some((anexo: any) => anexo.pedidoMedico)
    if (pedidoMedico) {
      const anexo = this.anexos.find((anx: any) => anx.pedidoMedico && !anx.particular)
      anexos.push({ url: anexo.url, nomeOriginalArquivo: 'Pedido médico' })

      const anexoParticular = this.anexos.find((anx: any) => anx.pedidoMedico && anx.particular)
      if (anexoParticular) {
        anexos.push({ url: anexoParticular.url, nomeOriginalArquivo: 'Pedido médico particular' })
      }
    }
    return anexos
  }

  get attachmentsByType() {
    return [
      { title: 'Operadora', attachments: this.getAttachmentsByType(TipoDocumentoUpload.AnexoOperadora) },
      { title: 'Cotação', attachments: this.getAttachmentsByType(TipoDocumentoUpload.CotacaoOpme) },
      { title: 'Laudos', attachments: this.getAttachmentsByType(TipoDocumentoUpload.Laudo) },
      { title: 'Documentação do paciente', attachments: this.getAttachmentsByType(TipoDocumentoUpload.DocumentacaoPaciente) },
      { title: 'Laudos do anestesista', attachments: this.getAttachmentsByType(TipoDocumentoUpload.LaudoAnestesista) },
      { title: 'Pedido sem assinatura', attachments: this.getAttachmentsByType(TipoDocumentoUpload.PedidoMedicoSemAssinatura) },
      { title: 'Documentos diversos', attachments: this.getAttachmentsByType(TipoDocumentoUpload.DocumentosDiversos) },
      { title: 'Avaliação Pré-operatória Antecipada', attachments: this.getAttachmentsByType(TipoDocumentoUpload.AvaliacaoRiscoPreOperatoria) },
    ]
  }

  get bateMapaTemplate() {
    return this.getBackofficeMapaCirurgicoStore.templateMapaCirurgico
  }


  getAttachmentsByType(tipoDocumento: TipoDocumentoUpload) {
    const attachments: any[] = []
    if (this.anexos) {
      const filteredAttachments = this.anexos.filter(c => c.tipoDocumento === tipoDocumento)
      filteredAttachments.map((a) => {
        attachments.push({ url: a.url, nomeOriginalArquivo: a.nomeOriginalArquivo })
        return a
      })
    }
    return attachments
  }

  getAllHospitaisId() {
    return this.getBackofficeMapaCirurgicoStore.hospitais.map((h: any) => h.id)
  }

  async created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
    await this.getBackofficeMapaCirurgicoStore.getAllHospitais()
    await this.getBackofficeMapaCirurgicoStore.getTemplateMapaCirurgico()
  }

  mounted() {
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    EventBus.$on('updateItensMapaCirurgico', async (response) => {
      if (response) await this.getBackofficeMapaCirurgicoStore.loadAgendamentosMedicoSearch()
    })
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
}
